<script setup lang="ts">
import { computed } from 'vue';
import { ForecastedWindow } from '@/data/ForecastedWindow.ts';

const props = defineProps<{ window: ForecastedWindow }>();

const iconName = computed(() => {
  switch (props.window.weatherCode) {
    case 0:
      return 'fa-sun';
    case 1:
    case 2:
      return 'fa-cloud-sun';
    case 3:
      return 'fa-cloud';
    case 51:
    case 53:
    case 55:
    case 56:
    case 57:
    case 61:
    case 63:
    case 65:
    case 66:
    case 67:
      return 'fa-cloud-showers-heavy';
    case 95:
    case 96:
    case 99:
      return 'fa-cloud-bolt';
    case 999:
      return 'fa-moon';
    default:
      return 'fa-question';
  }
});
</script>

<template>
  <font-awesome-icon :icon="iconName"/>
</template>

<style scoped>

</style>